angular.module('comment')
    .filter('mentionFilter', function($sce) {
        return function(input) {
            let removeSpaces = true

            if (!input) return input;

            let mentionPattern = /@\[(.*?):[^\]]+\]/g;

            let styledText = input.replace(mentionPattern, (match, name) => {
                let cleanName = name
                if(removeSpaces) {
                    cleanName = name.replace(/\s+/g, '');
                }
                return `<span class="mention-in-comment">@${cleanName}</span>`;
            });
            // let styledText = input.replace(mentionPattern, '<span class="mention-in-comment">@$1</span>');
            return $sce.trustAsHtml(styledText);
        };
    })
    .directive('mentionUser', function (User, $parse) {
        return {
            require: ['ngModel', 'uiMention'],
            link: function link($scope, $element, $attrs, controllers) {
                const ngModel = controllers[0]
                const uiMention = controllers[1]

                uiMention.findChoices = (match, mentions) => {
                    return User.autocomplete({q: match[1]}).$promise.then(users => users.slice(0, 5))
                };

                uiMention.label = choice => choice.fullName;

                // ui-mention stores user objects only in its local controller. These optional
                // attributes allow another mention field to render a copied, encoded comment.
                if ($attrs.mentionUserModel) {
                    const mentionModel = $parse($attrs.mentionUserModel)
                    if (mentionModel.assign) {
                        $scope.$watchCollection(
                            () => uiMention.mentions,
                            mentions => mentionModel.assign($scope, (mentions || []).slice())
                        )
                    }
                }

                if ($attrs.mentionUserSource) {
                    const mentionSource = $parse($attrs.mentionUserSource)

                    const synchronizeMentions = () => {
                        const value = (ngModel.$modelValue || '').toString()
                        const mentions = [
                            ...(uiMention.mentions || []),
                            ...(mentionSource($scope) || [])
                        ]
                        const synchronized = new Set()

                        uiMention.mentions = mentions.filter(mention => {
                            const encoded = uiMention.encode(mention)
                            if (synchronized.has(encoded) || value.indexOf(encoded) === -1) {
                                return false
                            }
                            synchronized.add(encoded)
                            return true
                        })
                        ngModel.$processModelValue()
                    }

                    $scope.$watchCollection(
                        () => mentionSource($scope),
                        synchronizeMentions
                    )
                    $scope.$watch(
                        () => ngModel.$modelValue,
                        synchronizeMentions
                    )
                }
            }
        }
    })
    // .directive('inputCommentMention', function () {
    //     return {
    //         restrict: 'E',
    //         require: '?ngModel',
    //         scope: {
    //             onChange: "&",
    //         },
    //         template: `
    //             <div class="mention-container">
    //                 <div class="input-group input-group-sm">
    //                     <span class="input-group-addon"><i class="fa fa-fw fa-comments"></i></span>
    //                     <textarea ui-mention mention-user ng-model="text" placeholder="{{ 'comment.new.button-mention' | translate }}" ng-trim="false" class="form-control" ng-show="showTextareaComment"></textarea>
    //                     <div class="mention-highlight"></div>
    //                 </div>
    //
    //
    //                 <ul ng-if="$mention.choices.length" class="dropdown-mention">
    //                     <li ng-repeat="choice in $mention.choices" ng-class="{active:$mention.activeChoice==choice}" ng-click="$mention.select(choice)">
    //                         <a href>
    //                             <user-list items="[choice]"></user-list>
    //                         </a>
    //                     </li>
    //                 </ul>
    //             </div>
    //         `,
    //         link: function (scope, $element, $attrs, ngModelCtrl) {
    //             let showTextareaComment = true;
    //
    //             ngModelCtrl.$render = () => scope.text = ngModelCtrl.$viewValue;
    //             ngModelCtrl.$formatters.push(modelValue => modelValue);
    //             ngModelCtrl.$parsers.push(viewValue => viewValue);
    //         }
    //     }
    // })
    .component('documentComments', {
        bindings: {
            document: '<',
            type: '<'
        },
        templateUrl: 'app/comment/document-comments.html',
        controller: function ($scope, $rootScope, toastr, Document, User) {

            this.$onInit = () => {
                Document.comments({type: this.type, id: this.document}).$promise.then(comments => this.comments = comments);
                this.newComment = {};
                this.showTextareaComment = true;
            }

            this.postComment = () => {
                this.isSaving = true;
                Document.postComment({type: this.type, id: this.document}, this.newComment).$promise
                    .then(() => {
                        this.$onInit();
                        toastr.success("Zapisano");
                        $rootScope.$broadcast('document.comments.added', {
                            type: this.type,
                            id: this.document
                        })
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            };

            this.switchDateFormat = () => {
                this.dateFormat = this.dateFormat == null? "medium" : (this.dateFormat === 'medium' ? 'mediumDate' : null);
            }
            $scope.$on('document.comments.reload', () => this.$onInit());

            // scope.users = [];
//             User.autocomplete().$promise.then(users => {
//                 scope.users = users.map(user => {
//                     return {
//                         ...user,
//                         label: user.login
//                     }
//                 })
//             });
//
//             // mentio
//             // mentio-typed-text="typedTerm"
//             // mentio-items="users | filter:label:typedTerm"
//             // mentio-template-url="users-mentions.tpl"
//             // mentio-select="mentionSelect(item)"
//
//             scope.mentionSelect = (mention) => {
//                 return `@${mention.login}[user=${mention.id}]`;
//             }
//
        }
    })
    // .directive('userMention', function(User){
    //     return {
    //         require: 'uiMention',
    //         link: function($scope, $element, $attrs, uiMention) {
    //
    //             uiMention.label = function(choice) {
    //                 return choice.login;
    //             };
    //
    //             uiMention.findChoices = function(match, mentions) {
    //                 return User.autocomplete({q: match[1]}).$promise;
    //                 // return $http.get(...).then(...);
    //             };
    //         }
    //     };
    // })
